import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredTrue(control: AbstractControl): ValidationErrors | null {
  if (control.value?.toString() !== 'true') {
    return { requiredTrue: true };
  }

  return null;
}
